module.exports = new __parcel__URL__("marine2.c304fe95.jpg").toString();